import React from 'react'

const Stats = ({ stats }) => {
  return (
    <>
      <div className="px-4 md:px-6 mt-1 mb-0">
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
          <div className="flex flex-wrap items-center gap-2 text-sm">
            <span className="font-medium text-gray-800">Celkem: {stats?.listingStatus.total} nemovitostí</span>
            <span className="text-gray-300">|</span>
            <span className="text-green-600 font-medium">Aktivní: {stats?.listingStatus.active}</span>
            <span className="text-gray-300">|</span>
            <span className="text-gray-600">Ukončené: {stats?.listingStatus.completed}</span>
          </div>
        </div>
      </div>
      {/* <div className="hidden sm:block bg-gray-100 p-4 m-4 rounded shadow">
        <div className="flex flex-col gap-8">
          <div className="grid grid-cols-4 gap-8">
            <div>
              <div className="font-medium mb-1">Průměr:</div>
              <div>Plocha: {Math.round(stats?.mean.m2)} m²</div>
              <div>Cena: {Math.round(stats?.mean.price)?.toLocaleString()} Kč</div>
              <div>Cena za m²: {Math.round(stats?.mean.m2Price)?.toLocaleString()} Kč</div>
            </div>
            <div>
              <div className="font-medium mb-1">Medián:</div>
              <div>Plocha: {Math.round(stats?.median.m2)} m²</div>
              <div>Cena: {Math.round(stats?.median.price)?.toLocaleString()} Kč</div>
              <div>Cena za m²: {Math.round(stats?.median.m2Price)?.toLocaleString()} Kč</div>
            </div>
            <div>
              <div className="font-medium mb-1" title="Medián vážený stářím inzerátu a rychlostí prodeje">
                Vážený medián:
              </div>
              <div>Plocha: {Math.round(stats?.weightedMedian.m2)} m²</div>
              <div>Cena: {Math.round(stats?.weightedMedian.price)?.toLocaleString()} Kč</div>
              <div>Cena za m²: {Math.round(stats?.weightedMedian.m2Price)?.toLocaleString()} Kč</div>
            </div>
            <div>
              {stats?.timeToSell ? (
                <>
                  <div className="font-medium mb-1" title="Doba od vytvoření do stažení inzerátu (pouze ukončené)">
                    Doba prodeje:
                  </div>
                  <div>
                    Průměr: {Math.round(stats.timeToSell.mean)} {Math.round(stats.timeToSell.mean) === 1 ? 'den' : Math.round(stats.timeToSell.mean) < 5 ? 'dny' : 'dní'}
                  </div>
                  <div>
                    Medián: {Math.round(stats.timeToSell.median)} {Math.round(stats.timeToSell.median) === 1 ? 'den' : Math.round(stats.timeToSell.median) < 5 ? 'dny' : 'dní'}
                  </div>
                  <div className="mt-2 text-sm">
                    <div className="text-green-600">Rychlý prodej (do 60 dní): {stats.timeToSell.quick}</div>
                    <div className="text-yellow-600">Běžný prodej (60-180 dní): {stats.timeToSell.normal}</div>
                    <div className="text-red-600">Pomalý prodej (nad 180 dní): {stats.timeToSell.slow}</div>
                  </div>
                </>
              ) : (
                <div className="font-medium text-gray-500">Zatím nejsou k dispozici data o době prodeje</div>
              )}
            </div>
          </div>
          //  <div>
          //   <div className="font-medium mb-1" title="Vývoj mediánu cen za posledních 12 týdnů">
          //     Vývoj cen:
          //   </div>
          //   <PriceTrends weeklyTrends={stats?.weeklyTrends} offerType={offerType} />
          // </div> 
        </div>
      </div> */}
    </>
  )
}

export default Stats
